<template>
  <div class="bodywarp">
    <el-card class="box-card boxcard" style="min-height:calc(100% - 30px)">
      <!-- <div slot="header" class="clearfix"><b>报价列表</b></div> -->
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="公司名称">
          <el-select v-model="formInline.cztcode" clearable placeholder="请选择">
            <el-option v-for="item in selectlist" :key="item.ccorpcode" :label="item.ccorpname" :value="item.ccorpcode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物料名称">
          <el-input v-model="formInline.cpartnumber" placeholder="物料名称"></el-input>
        </el-form-item>


        <el-form-item label="违规日期">
          <el-date-picker v-model="formInline.ddata" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        
        <el-form-item>
          <Debounce :time='300' :isDebounce="1">
            <el-button type="primary" @click.native="GitHtsigningList" size="medium">查询</el-button>
          </Debounce>
        </el-form-item>
      </el-form>

      <el-table :data="tableData" border style="width: 100%" max-height="560" highlight-current-row :header-cell-style="{ background: '#eef1f6', textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <!-- <el-table-column prop="cisqy" label="是否确认" width="100"></el-table-column> -->
        <el-table-column prop="cisvencommit" label="整改状态" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.cisvencommit">
              <el-tag type="success" size="small" v-if="scope.row.cisvencommit=='已提交'">{{scope.row.cisvencommit}}</el-tag>
              <el-tag type="success" size="small" v-if="scope.row.cisvencommit=='整改完毕'">{{scope.row.cisvencommit}}</el-tag>
              <el-tag type="danger" size="small" v-else effect="dark">{{scope.row.cisvencommit}}</el-tag>
            </span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="cisvencommit" label="供应商是否提交" width="100"></el-table-column> -->
        <el-table-column prop="cinvname" label="物料名称" min-width="150"></el-table-column>
        <el-table-column prop="ccorpname" label="工厂" min-width="180"></el-table-column>
        <el-table-column prop="cnumber" label="数量" width="120"></el-table-column>
        <!-- <el-table-column prop="cpartname" label="零(部)件名称" width="160"></el-table-column> -->
        <!-- <el-table-column prop="cpartnumber" label="零(部)件件号" width="120"></el-table-column> -->
        <!-- <el-table-column prop="csupcode" label="供方代码" min-width="120"></el-table-column> -->
        <el-table-column prop="czrminister" label="供应商质保部长" width="140"></el-table-column>
        <!-- <el-table-column prop="czrsupplier" label="责任供方" width="100"></el-table-column> -->
        <el-table-column prop="czrverifier" label="供应商方验证人" width="120"></el-table-column>
        <el-table-column prop="dissuedate" label="发出日期" width="100"></el-table-column>
        <el-table-column prop="dqydate" label="整改截止时间" width="120"></el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" plain @click="supedit(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pull-right" style="padding:20px;">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10,20, 50, 100, 1000]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      formInline: {
        cpartnumber: "",
        cztcode: "",
        ddeliverytime: [],
      },
      options: [
        {
          value: "1",
          label: "已确认",
        },
        {
          value: "2",
          label: "未确认",
        },
      ],
      // 牧场
      selectlist: {},
      // 分页
      pageSize: 20,
      pageIndex: 1,
      // 页数
      totalCount: 0,
      informdatanew: {},
    };
  },
  created() {
    if (this.$route.query.informdata) {
      if (this.$route.query.informdata.cpartname != undefined) {
        this.formInline = {};
        this.formInline = this.$route.query.informdata;
      }
    }
    this.GitHtsigningList();
    this.GetAccountInfo();
  },
  methods: {
    // 获取信息
    GitHtsigningList() {
      this.informdatanew = JSON.parse(JSON.stringify(this.formInline));
      var starttime;
      var endtime;
      if (this.formInline.ddeliverytime != null) {
        if (this.formInline.ddeliverytime.length != 0) {
          starttime = this.formInline.ddeliverytime[0];
          endtime = this.formInline.ddeliverytime[1];
        } else {
          starttime = "";
          endtime = "";
        }
      } else {
        starttime = "";
        endtime = "";
      }
      this.$axios({
        method: "post",
        url: "CommonModule/Op_Supplier/GetBadFeedbackList",
        data: {
          cpartnumber: this.formInline.cpartnumber,
          startDate: starttime,
          endDate: endtime,
          cztcode: this.formInline.cztcode,
          pageSize: this.pageSize,
          pageIndex: this.pageIndex,
        },
      }).then((res) => {
        console.log(res, "获取信息结果");
        this.loading = false;
        if (res.data.Success) {
          // this.tableData = res.data.Data;
          this.tableData = res.data.Data.rows;
          this.totalCount = res.data.Data.totalCount;
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },
     // 获取公司信息
    GetAccountInfo() {
      this.$axios({
        method: "post",
        url: "CommonModule/Op_StoreAndInvoice/GetAccountInfo",
      }).then((res) => {
        console.log(res);
        if (res.data.Success) {
          if (res.data.Message) {
            this.selectlist = res.data.Data;
          }
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.GitHtsigningList();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GitHtsigningList();
    },
    // 确认
    supedit(row) {
      this.$router.push({
        name: "Rectification",
        params: { rows: row, informdata: this.informdatanew },
      });
    },
  },
};
</script>
<style scoped>
.inputwidth {
  width: 30%;
}
.inputwidth .el-input__inner {
  border: 0;
}
</style>
